import { HardwareType } from "src/data/devices/types/deviceTypes"

import { usePostTrackEventWithParams } from "./analyticsQueries"

type TDeviceEventTypes = "Sensor clicked"

function usePostDeviceTrackingEvent<TEventProperties>(
  event: TDeviceEventTypes
) {
  return usePostTrackEventWithParams<TDeviceEventTypes, TEventProperties>({
    event,
  })
}

export function usePostDeviceSensorClicked() {
  return usePostDeviceTrackingEvent<{
    type: keyof typeof HardwareType
  }>("Sensor clicked")
}
